<!-- eslint-disable -->
<template>
    <el-container>
        <el-row class="list-container">
            <el-col :span="24" style="display: flex;">
                <div>
                  <el-button @click="refreshData" type="primary" size="small" icon="iconfont icon-shuaxin shuaxin">刷新</el-button>
                  <el-button type="success" size="small" icon="iconfont icon-daochu shuaxin" @click="exportExcel" :disabled="!power.recharge_excel">导出Excel</el-button>
                </div>
                <div style="padding-left: 10px;"><el-tag effect="plain">总充值金额：{{money_sum}}</el-tag></div>
            </el-col>

            <!-- search start  -->
            <el-col :span="24" class="search-content">
                <div class="search-item">
                  <el-date-picker
                    v-model="data.created_at"
                    size="small"
                    :picker-options="pickerOptions"
                    type="datetimerange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    start-placeholder="下单开始时间"
                    end-placeholder="下单结束时间">
                  </el-date-picker>
                </div>
                <div class="search-item" style="width: 150px;">
                    <el-select v-model="data.staff_id" placeholder="请选择员工" size="small" clearable>
                        <el-option
                            v-for="item in staffList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="search-item" style="width: 150px;">
                    <el-select v-model="data.status" placeholder="请选择支付状态" size="small" clearable>
                        <el-option
                            v-for="item in [
                              {id: 1, name: '已支付'},
                              {id: 0, name: '未支付'},
                            ]"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="search-item">
                    <el-input v-model="data.phone" size="small" type="number" placeholder="请输入会员手机号码" clearable></el-input>
                </div>
                <div class="search-item">
                    <el-button size="small" icon="iconfont icon-fangdajing shuaxin" @click="search">搜索</el-button>
                </div>
            </el-col>
            <!-- search end  -->

            <el-col class="main-content">
                <el-table :data="dataList" border @selection-change="handleSelectionChange" v-loading="loading" style="width: 100%">
                    <el-table-column prop="id" label="ID" width="80"></el-table-column>

                    <el-table-column prop="order_no" label="订单编号" width="180"></el-table-column>
                    <el-table-column prop="user_id" label="会员昵称" width="180">
                      <template slot-scope="scope">
                        <span>{{scope.row.nickname}} (ID: {{scope.row.user_id}})</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="phone" label="手机号码" width="150"></el-table-column>
                    <el-table-column prop="staff_name" label="加油员工姓名" width="150"></el-table-column>
                    <el-table-column prop="type" label="油品类型" width="100">
                      <template slot-scope="scope">
                        <span v-if="scope.row.type == 1">汽油</span>
                        <span v-if="scope.row.type == 2">柴油</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="money" label="充值金额" width="100"></el-table-column>
                    <el-table-column prop="money_end" label="当前余额" width="100"></el-table-column>
                    <el-table-column prop="status" label="支付状态" width="100">
                      <template slot-scope="scope">
                        <span v-if="scope.row.status == 1" style="color: #67C23A;">已支付</span>
                        <span v-else style="color: #F56C6C;">未支付</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="created_at" label="下单时间" min-width="180"></el-table-column>
                </el-table>
            </el-col>
            <el-col class="pagination">
                <el-pagination
                    @current-change="changePage"
                    @size-change="changePageSize"
                    background
                    :layout="pageLayout"
                    :page-sizes="pagePageSizes"
                    :page-size="pagePageSize"
                    :total="totalCount"
                    :current-page.sync="current_page"
                    :hide-on-single-page="false">
                </el-pagination>
            </el-col>
        </el-row>

    </el-container>
</template>

<!-- eslint-disable -->
<script>
    import {RechargeIndex} from "@/utils/request.js"
    import {mapState} from "vuex"

    export default {
        data(){
            return {
                data: {
                    page: 1,
                    page_size: this.pagePageSize,
                    staff_id: '',
                    status: '',
                    phone: '',
                    created_at: '',
                },
                loading: false,
                dataList: [],
                totalCount: 0,
                money_sum: 0,
                staffList: [],
                current_page: 1,
                multipleSelection: [],
                pickerOptions: {
                  shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                      const end = new Date();
                      const start = new Date();
                      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                      picker.$emit('pick', [start, end]);
                    }
                  }, {
                    text: '最近一个月',
                    onClick(picker) {
                      const end = new Date();
                      const start = new Date();
                      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                      picker.$emit('pick', [start, end]);
                    }
                  }, {
                    text: '最近三个月',
                    onClick(picker) {
                      const end = new Date();
                      const start = new Date();
                      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                      picker.$emit('pick', [start, end]);
                    }
                  }]
                },
            }
        },
        created() {
            this.getList()
        },
        computed: mapState(["power", "loginInfo"]),
        methods: {
            search() {
                this.data.page = 1
                this.current_page = 1
                this.getList()
            },
            refreshData() {
                this.data.page = 1
                this.current_page = 1
                this.loading = true

                this.getList()
            },
            getList() {
                this.loading = true
                RechargeIndex(this.data).then((res) => {
                    if (res.code == 200) {
                        this.data.page++
                        this.dataList = res.data.data
                        this.totalCount = res.data.count
                        this.money_sum = res.data.money_sum
                        this.staffList = res.data.staffList
                    } else {
                        this.$message.error("数据获取失败!")
                    }
                    this.loading = false
                })
            },
            changePage(page) {
                this.data.page = page
                this.getList()
            },
            changePageSize(size) {
                this.data.page_size = size
                this.data.page = 1
                this.current_page = 1
                this.getList()
            },

            handleSelectionChange(val) {
                this.multipleSelection = []
                if (val.length > 0) {
                    val.filter((item) => {
                        this.multipleSelection.push(item.id)
                    })
                }
            },
            exportExcel(type) {
              this.$confirm("确定要导出列表数据吗?", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "success"
              }).then(() => {
                  let url = '';
                  for(var k in this.data){
                    let value = this.data[k] !==undefined ? this.data[k] : '';
                    if (k == 'page') { continue }
                    url += `&${k}=${encodeURIComponent(value)}`
                  }
                  url += `&type=${type}`
                  if (this.loginInfo.id == 1) {
                    url += `&auth=xj2020`
                  }
                  location.href = this.loginInfo.app_url+'/manage/recharge/excel?' + url.substring(1)
              }).catch(() => {
                  // 取消操作
              });
            },
        }
    }
</script>

<style>
</style>
